import { StyleSheet } from '@react-pdf/renderer';

export const pdfStyles = StyleSheet.create({
	page: {
		fontFamily: 'Roboto',
		padding: '10px',
		fontWeight: 'medium',
	},
	arabic: {
		fontFamily: 'Amiri',
		fontWeight: 'light',
	},
	title: {
		fontSize: '14px',
		fontWeight: 'bold',
		marginBottom: '2px',
		marginTop: '5px',
	},
	section: {
		marginBottom: '8px',
		marginTop: '8px',
	},
	heading: {
		fontSize: '22px',
		textAlign: 'center',
		fontWeight: 'bold',
		marginBottom: '10px',
	},
	heading2: {
		fontSize: '18px',
		textAlign: 'center',
		fontWeight: 'bold',
		marginBottom: '10px',
	},
	heading3: {
		fontSize: '14px',
		textAlign: 'center',
		fontWeight: 'bold',
	},
	text: {
		fontSize: '13px',
	},
	table: {
		backgroundColor: '#fff',
	},
	tr: {
		display: 'flex',
		flexDirection: 'row',
	},
	td: {
		border: '1px solid #000',
		width: '100%',
		padding: '5px 10px',
		fontSize: '14px',
	},
	th: {
		border: '1px solid #000',
		width: '100%',
		padding: '4px 10px',
		fontSize: '14px',
		fontWeight: 'bold',
	},
	result: {
		fontSize: '16px',
		fontWeight: 'bold',
	},
	bottom: {
		margin: '10px 0',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	rejected: {
		color: 'red',
	},
	approved: {
		color: 'green',
	},
	review: {
		color: 'orange',
	},
});
